




























































































































































































import mixin from './mixin'
import {
  FindStatusStackLogic,
  StatusStackLogic,
  PatchStatusStackLogic,
  StatusStack,
  FindStatusStack,
  ReorderStatusStackLogic,
} from '@/api/cems'
import draggable from 'vuedraggable'

interface TableItem {
  item: StatusStackLogic
  showDetails: boolean
}

export default mixin.extend({
  name: 'ChimenyStatus',
  components: {
    draggable,
  },
  data() {
    return {
      status: [] as StatusStack[],
      tableItems: [] as TableItem[],
      stackUid: '',
    }
  },
  methods: {
    async findStatusStack() {
      this.status = await FindStatusStack()
      const statusLogic = await FindStatusStackLogic(this.stackUid)
      this.tableItems = []
      for (let i = 0; i < statusLogic.length; i++) {
        this.tableItems.push({
          showDetails: false,
          item: statusLogic[i],
        })
      }
    },

    async patchStatusStackLogic(logic: StatusStackLogic) {
      await PatchStatusStackLogic(this.stackUid, logic.id, logic)
      await this.findStatusStack()
    },

    toggleDetails(row: TableItem) {
      row.showDetails = !row.showDetails
    },

    hideDetails(row: TableItem) {
      row.showDetails = false
    },

    // TODO: Memperbaiki posisi row details yang kacau ketika urutan row nya diubah.
    async onOrderUpdate() {
      console.log('Do do')
      for (let index = 0; index < this.tableItems.length; index++) {
        console.log(index)
        this.tableItems[index].item.order = index + 1
      }
      // const logics: StatusStackLogic[] = this.tableItems.map((item, index) => {
      //   console.log(index)
      //   return item.item
      // })
      // await ReorderStatusStackLogic(logics)
      // await this.findStatusStack()
    },
  },

  async created() {
    this.stackUid = this.$route.params.stackUID
    this.findStatusStack()
  },
})
